import { config } from "../../../../fanpage/it/lib/config/production.js";
import { FanpageModuleLoader } from "../../../../fanpage/it/pa/modularization/FanpageModuleLoader.js";

const al = new FanpageModuleLoader(window, config);
const gui = al.getGui();